export default function Marquee({ items, dark = false }) {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-serif uppercase tracking-tight text-4xl md:text-6xl px-6 md:px-10 ${
              i % 2 === 0
                ? dark
                  ? "text-sand/90"
                  : "text-ink/85"
                : dark
                  ? "text-outline-sand"
                  : "text-outline"
            }`}
          >
            {item}
          </span>
          <span
            aria-hidden="true"
            className={`h-2 w-2 rounded-full ${dark ? "bg-sand/40" : "bg-ink/30"}`}
          />
        </span>
      ))}
    </div>
  );

  return (
    <div
      aria-hidden="true"
      className={`overflow-hidden border-y select-none py-6 md:py-8 ${
        dark ? "border-sand/15 bg-ink" : "border-line bg-sand"
      }`}
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
